import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { withRouter } from 'app/helpers/routing';
import { userIdentityShape, routerShape } from '@bibliocommons/bc-prop-types';
import { Shelves } from '@bibliocommons/deprecated-base-icons';
import { Dropdown } from '@bibliocommons/deprecated-base-dropdown';

import Context from '@bibliocommons/context';
import { SUMMARY_ORDER } from 'app/constants/ShelfConstants';
import UserHeaderNav from './UserHeaderNav';
import UserHeader from './UserHeader';
import './ShelfHeader.scss';

export class ShelfHeader extends React.PureComponent {
  getNavItems() {
    const { currentShelfName, summary, router } = this.props;
    const orderedSummary = summary.get('shelves').sortBy(shelf => SUMMARY_ORDER.indexOf(shelf.get('name')));

    return orderedSummary.map(shelf => {
      const shelfName = shelf.get('name');
      const label = shelf.get('label') || <FormattedMessage id={`label_${shelfName}_shelf`} />;
      const basePath = router.params.userId ? `/v2/users/${router.params.userId}/shelves` : '/v2/shelves';

      return Immutable.Map({
        key: `shelf_${shelfName}`,
        dataKey: `shelf-link-${shelfName}`,
        shelfName,
        itemCount: shelf.get('count', 0),
        label: (
          <span className="nav-item-label">
            {label} ({shelf.get('count')})
          </span>
        ),
        link: `${basePath}/${shelfName}`,
        value: `${basePath}/${shelfName}`,
        active: shelfName === currentShelfName
      });
    });
  }

  renderNav(navItems) {
    const { owner } = this.props;
    const heading = owner.get('loggedIn') ? 'section_title_my_shelves' : 'section_title_shelves';

    return (
      <UserHeaderNav
        renderHeading={() => <FormattedMessage id={heading} />}
        renderIcon={() => <Shelves />}
        isCurrentUser={owner.get('loggedIn')}
        items={navItems}
        userIdentity={owner}
      />
    );
  }

  renderMobileNav(navItems) {
    const currentShelf = navItems.find(item => item.get('active'));
    const classNames = cn('shelf-mobile-nav', { 'visible-xs': !this.context.mobileApp });

    return (
      <div className={classNames}>
        <Dropdown
          dataKey="shelf-header-dropdown"
          disableMobile
          selected={currentShelf?.get('label')}
          options={navItems.toJS()}
          handleSelect={href => this.props.router.push(href)}
          className="btn-link"
        />
      </div>
    );
  }

  renderUserHeader(navItems) {
    return !this.context.mobileApp ? (
      <UserHeader userIdentity={this.props.owner} renderNav={() => this.renderNav(navItems)} />
    ) : null;
  }

  render() {
    const navItems = this.getNavItems();

    return (
      <div className="row cp-shelf-header" data-current-shelf={this.props.currentShelfName}>
        {this.renderUserHeader(navItems)}
        {this.renderMobileNav(navItems)}
      </div>
    );
  }
}

ShelfHeader.propTypes = {
  currentShelfName: PropTypes.string.isRequired,
  owner: userIdentityShape.isRequired,
  summary: ImmutablePropTypes.contains({
    shelves: ImmutablePropTypes.list.isRequired
  }).isRequired,
  router: routerShape.isRequired
};

ShelfHeader.contextType = Context;

export default withRouter(ShelfHeader);
